import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { ResizeHelper, IDimConfig, LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { Point } from "pixi.js";

export class SplashText extends PIXI.Text {

    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new Point(1.75, 1.75),
                position: new Point(360, 300),
                layout: {
                    left: new Point(360, 300),
                    right: new Point(360, 300)
                }
            },
            portrait: {
                scale: new Point(1.75, 1.75),
                position: new Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };
    
    constructor(txt:string = "", style?:TextStyleOptions, dim?:IDimConfig) {
        super(txt, style);
        this.layoutDim = dim ? dim : this.layoutDim;
        // this.init();
    }

    // protected init():void {
    //     this.anchor.set(0, 0);
    // }

    public onResize(): void {
        const layoutdata: LayoutDimData = ResizeHelper.calcDim(this.layoutDim);
        // this.position = layoutdata.position;
        // this.scale = layoutdata.scale;
    }
}
